import ReactApexChart from "react-apexcharts";
import { Col } from "reactstrap";
import { rateChartData } from "../../../../Data/Dashboard/DashboardCharts/DashboardCharts";

const RateChart = () => {
  return (
    <Col sm="6">
      <ReactApexChart options={rateChartData} series={rateChartData.series} type="radialBar" height={350} id="rate-chart" />
    </Col>
  );
};

export default RateChart;
